import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Row,
  Col,
  Modal,
  Button,
  Container,
  Form,
  Tab,
  Tabs,
  OverlayTrigger,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

function ModalHitos(props) {
  const [datosTablaHitos, setDatosTablaHitos] = useState([]);

  let columnsHitos = [
    {
      dataField: "Nombre",
      text: "Hito",
      sort: true,
      headerStyle: { width: "50%" },
      headerClasses: "headerTablaHitos",
      classes: "cellColumnsTablaHitos",
      footer: "",
      footerClasses: "footerTablaHitos",
      formatter: (cell, row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "12px 8px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              fontSize: "15px",
              fontFamily: "'Work Sans', sans-serif",
              fontWeight: "500",
              color: "#3d2e66",
              lineHeight: "1.4",
            }}
          >
            {row.Nombre}
          </div>
        </div>
      ),
    },
    {
      dataField: "Asignado",
      text: "% Asignado",
      sort: true,
      headerStyle: { width: "22%", textAlign: "center" },
      classes: "cellColumnsTablaHitos",
      headerClasses: "headerTablaHitos",
      align: "center",
      footerAlign: (column, colIndex) => "center",
      footerClasses: "footerTablaHitos",
      footer: "Total",
      formatter: (cell, row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "8px",
          }}
        >
          <span
            style={{
              background: "linear-gradient(135deg, #f07f0d, #e6730c)",
              color: "white",
              padding: "6px 12px",
              borderRadius: "15px",
              fontSize: "16px",
              fontWeight: "600",
              textShadow: "0 1px 2px rgba(0,0,0,0.2)",

              minWidth: "50px",
              textAlign: "center",
            }}
          >
            {row.Asignado}
          </span>
        </div>
      ),
    },
    {
      dataField: "Avance",
      text: "% de avance acumulado",
      sort: true,
      //headerStyle: { width: "20%", textAlign: "center" },
      headerStyle: {
        textAlign: "center",
      },
      align: "center",
      classes: "cellColumnsTablaHitos",
      headerClasses: "headerTablaHitos",
      footerAlign: (column, colIndex) => "center",
      footerClasses: "footerTablaHitos",

      footer: (columnData) => {
        //console.log("columnData", columnData);
        //el ultimo valor del arreglo

        if (columnData.length > 0) {
          return columnData[columnData.length - 1] + "%";
        }
      },
      formatter: (cell, row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "8px",
          }}
        >
          <div style={{ width: "70px", height: "70px" }}>
            <CircularProgressbar
              value={row.Avance}
              text={`${row.Avance}%`}
              strokeWidth={8}
              styles={buildStyles({
                strokeLinecap: "round",
                trailColor: "#e9ecef",
                textSize: "26px",
                textColor: "#5d428b",
                pathColor: "#81ba27",
                text: {
                  fontWeight: "bold",
                  filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.2))",
                },
                pathTransition:
                  row.Avance === 0 ? "none" : "stroke-dashoffset 0.8s ease 0s",
              })}
            />
          </div>
        </div>
      ),
    },
  ];

  let data = [
    {
      id: 1,
      Nombre: "Hito 1",
      Asignado: "50%",
      Avance: "30",
    },
    {
      id: 2,
      Nombre: "Hito 2",
      Asignado: "20%",
      Avance: "60",
    },
    {
      id: 3,
      Nombre: "Hito 3",
      Asignado: "20%",
      Avance: "100",
    },
    {
      id: 4,
      Nombre: "Hito 4",
      Asignado: "10%",
      Avance: "100",
    },
  ];

  useEffect(() => {
    if (
      props.InformacionModal.Hitos !== undefined &&
      props.InformacionModal.Hitos.length > 0
    ) {
      let datos = [];
      props.InformacionModal.Hitos.map((item, index) => {
        let avance = 0;
        if (item.Avance !== undefined) {
          avance = item.Avance;
        }
        datos.push({
          Id: index + 1,
          Nombre: item.Hito,
          Asignado: item.Asignado,
          Avance: Number(avance.replace("%", "")),
        });
      });
      console.log("datos tabla hitos", datos);
      setDatosTablaHitos(datos);
    }
  }, []);

  return (
    <Modal
      show={props.MostrarModal}
      dialogClassName="modal-90w"
      style={{
        paddingRight: "0px",
        paddingTop: "2vh",
      }}
      keyboard={true}
      onHide={() => {
        props.CerrarModal();
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
      >
        <Modal.Header
          style={{
            background: "linear-gradient(135deg, #5d428b 0%, #3d2e66 100%)",
            borderRadius: "15px 15px 0 0",
            border: "none",
            padding: "20px 25px",
            position: "relative",
            overflow: "hidden",
          }}
          closeButton
          closeVariant="white"
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%)",
              animation: "shimmer 3s infinite",
            }}
          />
          <Modal.Title
            style={{
              color: "#fff",
              fontSize: "1.3rem",
              fontWeight: "700",
              fontFamily: "'Work Sans', sans-serif",
              textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              position: "relative",
              zIndex: 1,
            }}
          >
            {props.InformacionModal.Area}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
            padding: "20px",
            borderRadius: "0 0 15px 15px",
          }}
        >
          {/* Título de la iniciativa */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h5
              style={{
                color: "#5d428b",
                fontWeight: "700",
                fontFamily: "'Work Sans', sans-serif",
                marginBottom: "15px",
                textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                borderBottom: "2px solid #81ba27",
                paddingBottom: "8px",
              }}
            >
              {props.InformacionModal.NombreIniciativa}
            </h5>
          </motion.div>

          {/* Descripción */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <div
              style={{
                background: "rgba(255, 255, 255, 0.8)",
                borderRadius: "10px",
                padding: "15px",
                marginBottom: "18px",
                border: "1px solid rgba(93, 66, 139, 0.1)",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
              }}
            >
              <p
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontSize: "14px",
                  color: "#555",
                  lineHeight: "1.5",
                  margin: 0,
                  textAlign: "justify",
                }}
              >
                {props.InformacionModal.Descripcion}
              </p>
            </div>
          </motion.div>

          {/* Tabla de hitos */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <div
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                borderRadius: "10px",
                padding: "15px",
                marginBottom: "18px",
                border: "1px solid rgba(93, 66, 139, 0.1)",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
              }}
            >
              <BootstrapTable
                keyField="Id"
                data={datosTablaHitos}
                columns={columnsHitos}
                bordered={false}
              />
            </div>
          </motion.div>

          {/* Sección de resumen */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <div
              style={{
                background:
                  "linear-gradient(135deg, rgba(129, 186, 39, 0.1) 0%, rgba(129, 186, 39, 0.05) 100%)",
                borderRadius: "10px",
                padding: "18px",
                border: "2px solid #81ba27",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%)",
                  animation: "shimmer 4s infinite",
                }}
              />
              <h6
                style={{
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  color: "#5d428b",
                  marginBottom: "12px",
                  fontFamily: "'Work Sans', sans-serif",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                📋 Resumen de Avance
              </h6>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "'Work Sans', sans-serif",
                  fontSize: "14px",
                  color: "#444",
                  lineHeight: "1.5",
                  margin: 0,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {props.InformacionModal.Reporte}
              </p>
            </div>
          </motion.div>
        </Modal.Body>
      </motion.div>
    </Modal>
  );
}

export default ModalHitos;
